import React from 'react';
import { CreateUsersConfirmation } from '~/presentation/pages';

export const CreateUsersConfirmationFactory: React.FC = () => {
  return <CreateUsersConfirmation />;
};
